import React from 'react'
import {Checkbox as MuiCheckbox, FormHelperText, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import SimpleTable from 'components/complex/simpleTable/SimpleTable';
import Checkbox from 'components/Checkbox';
import getObjectValue from 'libs/getObjectValue';
import clsx from "clsx";


const style = theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    textBold: {
        fontWeight: theme.typography.fontWeightBold,
    },
    samllColumn: theme.components.table.lpColumn,
    orderColumn: theme.components.table.ipColumn,
    checkboxColumn: {
        width: theme.spacing()
    },
    cells: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    checkbox: {
        padding: 0,
    },
    cursor: {
        cursor: "pointer"
    }
})

function PartsTable(
    {
        classes,
        className,
        formikProps,
        id,
        elementList = [],
        label,
        orderLabel = "part_number",
        editable = true,
        required=true,
        disabled
    }) {
    const elements = getObjectValue(id, formikProps.values, []);
    const errorValue = getObjectValue(id, formikProps.errors, '');
    const touched = getObjectValue(id, formikProps.touched, false);
    const isAllChecked = elementList.length > 0 && !elementList.find(x => elements[x.identity] !== true)

    const handleHeadCheckboxChange = (e, value) => {
        const newElements = elementList.reduce((acc, x) => {
            return {
                ...acc,
                [x.identity]: value
            }
        }, {})
        formikProps.setFieldValue(id, newElements)
    }

    const isError = editable && !!errorValue && Boolean(touched);
    const helperText = errorValue || ' ';
    const hasOrder = !!(elementList?.[0]?.order);
    return (
        <GridBlock
            className={clsx(classes.root, className)}
            column
        >
            <Typography
                variant='body1'
                className={classes.textBold}
            >
                {label ? label : Tr('assign_to_part')}{required ? '*' : ''}
            </Typography>
            <SimpleTable
                headers={[
                    <MuiCheckbox
                        color='primary'
                        className={classes.checkbox}
                        onChange={handleHeadCheckboxChange}
                        checked={isAllChecked}
                        disabled={disabled}
                    />,
                    (hasOrder ?  Tr(orderLabel) : Tr('column_lp')),
                    Tr('name')
                ]}
                items={elementList.map((x, i) => {
                    return [
                        <Checkbox
                            id={`${id}.${x.identity}`}
                            formikProps={formikProps}
                            checkboxClassName={classes.checkbox}
                            htmlId={`${id}.${x.identity}`}
                            disabled={disabled}
                        />,
                        <label className={classes.cursor} htmlFor={`${id}.${x.identity}`}>{!!x.order ? x.order : i + 1}</label>,
                        <label className={classes.cursor} htmlFor={`${id}.${x.identity}`}>{x.name}</label>,
                    ]
                })}
                cellClassName={classes.cells}
                columnClasses={[
                    classes.checkboxColumn,
                    hasOrder ? classes.orderColumn : classes.samllColumn
                ]}
            />
            {isError && <FormHelperText error>{helperText}</FormHelperText>}
        </GridBlock>
    )
}

PartsTable.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(PartsTable);
